export const arrayBufferToBase64 = arrayBuffer => btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));